import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=75cee2ba&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=75cee2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cee2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75cee2ba')) {
      api.createRecord('75cee2ba', component.options)
    } else {
      api.reload('75cee2ba', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=75cee2ba&scoped=true&", function () {
      api.rerender('75cee2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P4lnR0dAT7V1/JS/comp/CookieBox.vue"
export default component.exports